export default __webpack_public_path__ + "static/data-vis-categorical-do-c64697274bd96a7ed83f64feb27a0dc46ef2b020e722bfb062764da948b04fa0.png";